module.exports = __webpack_public_path__ + "img/link.18c34027.svg";